import React from 'react';

export const CertCheckbox = (props) => (
	<label className="checkbox">
		<span className={props.labelClass}>
			{props.label}
		</span>
		<input 
			required={props.required}
			type="checkbox" 
			name={props.name}
			value={props.value}
			aria-checked={props.value}
			checked={props.value}
			onChange={props.onChange} />
		<span className="box-checkmark"></span>
		<span className="form-error">
    		<p>{props.errMessage}</p>
    	</span>
	</label>
);


// WEBPACK FOOTER //
// ./src/components/CertCheckbox/CertCheckbox.js